module.exports = __webpack_public_path__ + "static/commerce2x-pos-6dda2c095c2987ee5374fd01e7edcd36.png";